// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Dfot","title":"InfoRow_title__Few3r"};